<app-simulation-model-io
  [models]="models"
  [selectedModel]="selectedModel"
  (selectedModelChange)="onSelectedModelChange($event)"
  [showDelete]="true"
  (deleteModel)="deleteModel.emit($event)"
  (importModel)="onImportClick()"
  (exportModel)="onExportClick()">
</app-simulation-model-io>

<app-tabs [tabs]="modelTabs" [activeId]="activeModelTabId" (activeIdChange)="onTabChange($event)" variant="underline"
  [fullWidth]="true" (helpClicked)="onModelHelpClicked($event)">
</app-tabs>

<div class="models-form-wrapper">

  <div [hidden]="activeModelTabId !== 'basic'">
    <app-models-form #basicModelForm [formType]="'desired'" [initialValue]="basicUserListInitial"
      [showSaveFormatOption]="false" [mentionData]="mentionData" (mentionDataChange)="handleMentionDataChange($event)"
      (valueChange)="handleBasicFormChange($event)">
    </app-models-form>
  </div>

  <div [hidden]="activeModelTabId !== 'rules'">
    <app-models-form [formType]="'generalRules'" [initialValue]="generalRulesInitial" [showSaveFormatOption]="false"
      [mentionData]="mentionData" (valueChange)="handleRulesFormChange($event)">
    </app-models-form>
  </div>

  <div [hidden]="activeModelTabId !== 'questions'">
    <app-models-form [formType]="'generalQuestions'" [initialValue]="generalQuestionsInitial"
      [showSaveFormatOption]="false" [mentionData]="mentionData" (valueChange)="handleQuestionsFormChange($event)">
    </app-models-form>
  </div>

  <div [hidden]="activeModelTabId !== 'classification'">
    <app-classification-config [initialValue]="classificationInitial" [readonly]="false"
      (valueChange)="onClassificationChange($event)">
    </app-classification-config>
  </div>

  <div [hidden]="activeModelTabId !== 'references'" class="references-tab-content">
    <div class="reference-selector-wrapper">
      <ng-select [items]="allReferences" bindLabel="name" bindValue="id" [multiple]="true"
        [ngModel]="selectedReferences" (ngModelChange)="handleReferencesChange($event)"
        [placeholder]="'SEARCH.PLACEHOLDER.REFERENCES' | translate"
        [notFoundText]="'NG_SELECT.NO_ITEMS_FOUND' | translate">
      </ng-select>
    </div>
  </div>
</div>

<app-simulation-model-actions
  [modelName]="newModelName"
  (modelNameChange)="onNewModelNameChange($event)"
  [hasChanges]="hasChanges"
  [markSaveChanges]="true"
  [showSaveAndExecute]="hasChanges"
  [showWarning]="!hasArchives"
  [executeDisabled]="!hasArchives"
  (save)="onSaveOnlyClick()"
  (saveAndExecute)="onSaveAndExecuteClick()"
  (execute)="onExecuteClick()">
</app-simulation-model-actions>
